import React from "react";
import { Card, CardContent } from "./ui/card";
import {
  ExternalLink,
  Download,
  Clock,
  Shield,
  Check,
  Sparkles,
} from "lucide-react";
import phoneIcon from "../assets/images/phone.svg";
import playstore from "../assets/images/playstore.svg";
import apple from "../assets/images/apple.svg";

const BuyersWillBeInTouchScreen = ({ userData, onDownloadApp, onFullApp, onInsuranceProfile }) => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="text-center space-y-4">
        {/* <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
          <Check className="w-8 h-8 text-green-500" />
        </div> */}
        <div className="flex items-center justify-center mx-auto">
          <img src={phoneIcon} alt="phone icon" />
        </div>
        <h1 className="text-3xl font-bebasNeue !mt-9">
          Thanks for Sharing Your Profile
        </h1>
        <p className="text-darkGrey !mt-2">
          We’re actively reviewing your information. If a buyer is interested,
          they’ll reach out with an offer.
        </p>
        <p className="text-darkGrey !mt-2">
          In the meantime, download the Ownli app to unlock more earning options
          with your data
        </p>
      </div>

      {/* Status Card */}
      {/* <Card className="bg-blue-50 border-blue-100">
        <CardContent className="pt-6">
          <div className="flex items-start gap-3">
            <Clock className="w-5 h-5 text-blue-500 mt-1" />
            <div>
              <p className="font-medium text-blue-900">Profile Under Review</p>
              <p className="text-sm text-blue-700">
                We'll notify you when a buyer is interested in your data
              </p>
            </div>
          </div>
        </CardContent>
      </Card> */}

      <button
        onClick={onInsuranceProfile}
        className={`w-full flex items-center justify-center gap-2 uppercase font-bold bg-purpleGradient !mt-10 text-white px-4 py-3 rounded-[10px] hover:bg-purpleGradientDark transition-colors`}
      >
        Ownli Insurance Profile
      </button>

      <div className="flex items-center justify-center !my-4">
        <div className="border-t border-gray-400 flex-grow"></div>
        <span className="px-4 text-gray-400 text-base">or</span>
        <div className="border-t border-gray-400 flex-grow"></div>
      </div>

      <div className="flex items-center justify-center gap-2 md:gap-6 !mt-0">
        <a
          href="https://apps.apple.com/us/app/ownli/id1591218440"
          target="_blank"
          className="w-full flex cursor-pointer items-center bg-black text-white rounded-[10.75px] px-4 py-3 shadow hover:bg-gray-800 transition"
        >
          <img src={apple} alt="apple" className="mr-2"/>
          <div className="text-left">
            <div className="text-xs">Get it on</div>
            <div className="text-base font-semibold">App Store</div>
          </div>
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.joinparked.app&hl=en_IN"
          target="_blank"
          className="w-full flex cursor-pointer items-center bg-black text-white rounded-[10.75px] px-4 py-3 shadow hover:bg-gray-800 transition"
        >
          <img src={playstore} alt="playstore" className="mr-2" />
          <div className="text-left">
            <div className="text-xs">Get it on</div>
            <div className="text-base font-semibold">Google Play</div>
          </div>
        </a>
      </div>

      {/* Download App Card */}
      {/* <Card>
        <CardContent className="pt-6">
          <div className="text-center mb-4">
            <h2 className="font-medium text-gray-900">In the meantime...</h2>
            <p className="text-sm text-gray-600 mt-1">
              Download the Ownli app to unlock more earning options with your
              data
            </p>
          </div>

          <button
            onClick={onDownloadApp}
            className="w-full flex items-center justify-center gap-2 bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Download the App
            <Download className="w-4 h-4" />
          </button>
        </CardContent>
      </Card> */}

      {/* Features Card */}
      {/* <Card>
        <CardContent className="pt-6">
          <h3 className="font-medium text-gray-900 mb-3">More Ways to Earn with Ownli</h3>
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <Sparkles className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-gray-900">
                  Connect Your Vehicle Data
                </p>
                <p className="text-xs text-gray-600">
                  Earn rewards by sharing your driving data with trusted partners
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <Shield className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-gray-900">
                  Control Your Privacy
                </p>
                <p className="text-xs text-gray-600">
                  Choose what to share and with whom - you're always in control
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card> */}

      {/* Footer */}
      {/* <p className="text-xs text-center text-gray-500">
        We'll email you when interested buyers are found. You can download the
        Ownli app to track your profile status.
      </p> */}
    </div>
  );
};

export default BuyersWillBeInTouchScreen;
